import { InjectionToken } from '@angular/core';

export const STORAGE_TOKEN = new InjectionToken<Storage>('STORAGE_TOKEN', {
  providedIn: 'root',
  factory: () => sessionStorage,
});
